import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Title from "../../components/title";
import "./jobPerformanceEvaluation.css";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import RegisterTextbox from "../../components/RegisterTextBox";
import { Form, Spinner } from "react-bootstrap";
import RegisterSelect from "../../components/RegisterSelect";
import { useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton";
import { useNavigate } from "react-router";
import "react-datepicker/dist/react-datepicker.css";
import API from "../../api/axiosConfig";


function JobPerformanceEvaluation() {
  const [reviewGoal, setReviewGoal] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate()
  const [employees, setEmployees] = useState([]);
  const [date, setDate] = useState(new Date().toISOString().substr(0, 10));
  const [emp, setEmp] = useState('');
  const [period, setPeriod] = useState('');
  const [evaluator, setEvaluator] = useState('');
  const [reason, setReason] = useState('');
  const [type, setType] = useState('');
  const [description, setDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append('date', date);
    formData.append('emp', emp);
    formData.append('period', period);
    formData.append('evaluator', evaluator);
    formData.append('reason', reason);
    formData.append('type', type);
    formData.append('description', description);
    try {
      const res = await API.post(`evaluation/store`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }

      });
      const data = await res;
      if (data.status === 200) {
        navigate(`/kpievaluation/${data.data.id}`);
      }
    }
    catch (error) {
      console.error(error);
      setError(error.response.data.errors);
      setIsSubmitting(false);
    }
  };

  const handleReviewGoalChange = (e) => {
    setReviewGoal(e.target.value);
    setReason(e.target.value);
  };

  const handleIdNumberChange = (e) => {
    setIdNumber(e.target.value);
  };

  useEffect(() => {
    const getEmployees = async () => {
      try {
        const res = await API.post(`/employees`);
        const data = await res;
        if (data.status === 200) {
          setEmployees(data.data);
        }
      } catch (error) {
        console.error(error);
        setError(error.response.data.errors);
      }
    }
    getEmployees();
  }
    , []);

  return (
    <>
      <div className="JobPerformanceEvaluation">
        <Title
          title="نموذج تقييم الاداء الوظيفي"
          icon={<FontAwesomeIcon icon={faCheck} />}
          style={{ width: "unset" }}
        />
        <Form
          className="JobPerformanceEvaluation-inputsCon"
          onSubmit={handleSubmit}
        >
          <div className="JobPerformanceEvaluation-inputs">

            <div style={{ width: "30%", display: "flex", flexDirection: "column" }}>
              <p style={{ marginBottom: '10px' }}>تاريخ النموذج</p>
              <input
                type="date"
                id="formdata"
                className="custom-datepicker"
                style={{
                  width: "100%",
                }}
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
              {error && error.date && <span className="error">{error.date}</span>}
            </div>

            <RegisterTextbox
              parentStyle={{
                width: "30%",
              }}
              id="evaluationtime"
              label="فترة التقييم"
              type="text"
              stylee={{
                width: "50%",
              }}
              value={period}
              onChange={(e) => setPeriod(e.target.value)}
              error={error && error.period}
            />

          </div>

          <div className="JobPerformanceEvaluation-inputs">
            <RegisterSelect
              id="employees"
              stylee={{
                width: "45% !important",
              }}
              label="إسم الموظف"
              parentStyle={{
                width: "30%",
                marginBottom: "20px",
              }}
              options={[
                { value: "0", label: "اختر اسم الموظف" },
                ...employees.map((item) => ({
                  value: item.id,
                  label: item.name,
                })),
              ]}
              value={emp}
              onChange={(e) => setEmp(e.target.value)}
              error={error && error.emp}
            />

            <RegisterSelect
              id="employees"
              stylee={{
                width: "45% !important",
              }}
              label="إسم المسئول"
              parentStyle={{
                width: "30%",
                marginBottom: "20px",
              }}
              options={[
                { value: "0", label: "اختر اسم المسئول" },
                ...employees.map((item) => ({
                  value: item.id,
                  label: item.name,
                })),
              ]}
              value={evaluator}
              onChange={(e) => setEvaluator(e.target.value)}
              error={error && error.evaluator}
            />
          </div>
          <div className="JobPerformanceEvaluation-inputs">

            {/* {error && error.evaluator && <span className="error">{error.evaluator}</span>} */}
            <RegisterSelect
              id="reviewgoal"
              stylee={{
                width: "45% !important",
              }}
              parentStyle={{
                width: "30%",
                marginBottom: "20px",
              }}
              options={[
                { value: "0", label: "اختر الهدف من التقييم" },
                { value: "1", label: "تقييم دوري" },
                { value: "2", label: "فترة تجربة" },
                { value: "3", label: "ترقية" },
                { value: "4", label: "علاوة" },
                { value: "5", label: "اخري" },
              ]}
              value={reviewGoal}
              onChange={handleReviewGoalChange}
              error={error && error.reviewGoal}
            />
            {/* {error && error.reason && <span className="error">{error.reason}</span>} */}
            <RegisterSelect
              id="reviewtype"
              stylee={{
                width: "45% !important",
              }}
              parentStyle={{
                width: "30%",
                marginBottom: "20px",
              }}
              options={[
                { value: "0", label: "إختر نوع التقييم" },
                { value: "1", label: "تقييم الموظف" },
                {
                  value: "2",
                  label: "تقييم الرئيس المباشر",
                },
              ]}
              value={type}
              onChange={(e) => setType(e.target.value)}
              error={error && error.type}
            />
            {/* {error && error.type && <span className="error">{error.type}</span>} */}
          </div>

          <div className="JobPerformanceEvaluation-inputs">
            {reviewGoal === "5" && (
              <RegisterTextbox
                parentStyle={{
                  width: "20%",
                }}
                id="otherreviewgoal"
                label="الهدف من التقييم"
                type="text"
                stylee={{
                  width: "50%",
                }}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                error={error && error.description}
              />
            )}
            {/* {error && error.description && <span className="error">{error.description}</span>} */}
          </div>

          {isSubmitting ? <Spinner animation="border" variant="primary" /> : <CustomButton text="التالي" />}
        </Form>
      </div>
    </>
  );
}

export default JobPerformanceEvaluation;
